export default "__VITE_ASSET__BHF6uSpQ__"